import { render, staticRenderFns } from "./SaldoProduto.vue?vue&type=template&id=cf9ae82c&scoped=true"
import script from "./SaldoProduto.vue?vue&type=script&lang=js"
export * from "./SaldoProduto.vue?vue&type=script&lang=js"
import style0 from "./SaldoProduto.vue?vue&type=style&index=0&id=cf9ae82c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9ae82c",
  null
  
)

export default component.exports